const initialState = {
  total_pages: 1,
  current_page: 1,
  goal_subscriptions: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_GOALSUBSCRIPTIONS":
      return action.payload.goal_subscriptions;
    case "UPDATE_CURRENT_PAGE":
      return {
        ...state,
        current_page: action.payload.currentPage
      }
    default:
      return state;
  }
}